"use strict";

// Removed unused vimeo player.js import to avoid vimeo cookies (Version 3.0.6).

//todo remove when ts
// @ts-ignore
import { getPrefixedDataSet } from '../../data-set-utils';
// @ts-ignore
import { onFind } from "../../init-modules-in-scope";
// @ts-ignore
import { findIn, on } from "../../dom-utils";
// @ts-ignore
import loadScript from '../../load-script-valantic';
const defaultOptions = {
    licenseKey: '1F1E2926-4DA8-4BB1-8063-47DEEF510C8A',
    download: false,
    zoom: false,
    video: false,
    plugins: []
};
const defaultSelectors = {
    base: '.js-lightbox',
    item: '.js-lightbox__item'
};
export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createLightbox(baseElement, { ...defaultOptions, ...options }, { ...defaultSelectors, ...selectors });
    });
}
export function createLightbox(lightbox, options = defaultOptions, selectors = defaultSelectors) {
    let lightboxItems = findIn(selectors.item, lightbox);
    let elementOptions = {
        ...defaultOptions,
        ...options,
        ...getPrefixedDataSet('lightbox', lightbox)
    };
    let imports = [
        import('lightgallery')
    ];
    if (options.plugins) {
        options.plugins.map((item) => {
            imports.push(import('lightgallery/plugins/' + item + '/lg-' + item + '.umd.js'));
        });
    }
    let modules = [];
    imports.map((promise, index) => {
        if (index !== 0) {
            modules.push('module-' + index);
        }
    });
    Promise.all(imports).then(([lightGallery, ...modules]) => {
        elementOptions.plugins = [];
        lightGallery = lightGallery.default;
        modules.map((module) => {
            elementOptions.plugins.push(module.default);
        });
        if (elementOptions.dynamic && elementOptions.dynamicEl) {
            elementOptions.dynamicEl = JSON.parse(elementOptions.dynamicEl);
        }
        const lightboxInstance = lightGallery(lightbox, {
            ...elementOptions,
            selector: selectors.item,
        });
        //prevent isClickable
        const lightboxClickHandler = (evt) => {
            evt.stopImmediatePropagation();
            if (elementOptions.dynamic) {
                lightboxInstance.openGallery(0);
            }
        };
        if (lightboxItems) {
            on('click', lightboxClickHandler, lightboxItems);
        }
    });
}
